/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CsatByAnswerToOtherQuestionBarChart_answersReport = {|
  +csatByAnswerToOtherQuestion: ?$ReadOnlyArray<?{|
    +text: ?$ReadOnlyArray<?{|
      +language: ?string;
      +text: ?string;
    |}>;
    +csat: ?number;
    +count: ?number;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "otherQuestionMongoId",
      "type": "ID"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CsatByAnswerToOtherQuestionBarChart_answersReport",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "otherQuestionMongoId",
          "variableName": "otherQuestionMongoId",
          "type": "ID"
        }
      ],
      "concreteType": "CsatByAnswerToOtherQuestion",
      "name": "csatByAnswerToOtherQuestion",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Translation",
          "name": "text",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "language",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "csat",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswersReport"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/CsatByAnswerToOtherQuestionBarChart/__generated__/CsatByAnswerToOtherQuestionBarChart_answersReport.graphql.js